import Button from 'components/control/button';
import CameraIcon from 'components/icon/camera-icon';
import styles from './virtual-tour-button.module.scss';

export interface VirtualTourButtonProps {
  /** Pre-formatted button label */
  label: string;
  /** URL for the virtual tour */
  virtualTourUrl: string;
  /** Click handler (includes analytics) */
  onClick?: () => void;
  /** Optional className for styling */
  className?: string;
}

/**
 * VirtualTourButton - Button that opens virtual tour in new tab
 * 
 * @example
 * ```tsx
 * <VirtualTourButton
 *   label="Virtual Tour"
 *   virtualTourUrl="https://..."
 *   onClick={() => trackVirtualTourClick()}
 * />
 * ```
 */
export function VirtualTourButton({
  label,
  virtualTourUrl,
  onClick,
  className,
}: VirtualTourButtonProps) {
  if (!virtualTourUrl) {
    return null;
  }

  return (
    <a
      onClick={onClick}
      href={virtualTourUrl}
      className={className || styles.buttonWrapper}
      target="_blank"
      rel="nofollow noreferrer"
      data-testid="ui-virtual-tour-button"
    >
      <Button
        label={label}
        theme="secondary"
        Icon={CameraIcon}
      />
    </a>
  );
}

export default VirtualTourButton;
